import { LayerGroup } from '@carto/kepler.gl/reducers'

export enum MapStyleType {
  MAPLIBRE = 'mapLibre', // default, not required
  GOOGLE_MAPS = 'gmaps',
  AMAZON = 'amazon',
  CUSTOM = 'custom'
}

export interface KeplerMapStyle {
  type: MapStyleType
  id: string
  label: string
  icon?: string
  layerGroups?: LayerGroup[]
  url?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any

  // carto internal
  disabled?: boolean
  failedToLoad?: boolean
  customAttribution?: string
  originalUrl?: string
}

export enum GoogleMapsMapTypeId {
  ROADMAP = 'roadmap',
  SATELLITE = 'satellite',
  HYBRID = 'hybrid',
  TERRAIN = 'terrain'
}

export enum GoogleMapsFeatureType {
  ADMINISTRATIVE = 'administrative',
  LANDSCAPE = 'landscape',
  POI = 'poi',
  ROAD = 'road',
  TRANSIT = 'transit',
  WATER = 'water'
}
